let analysisQueue = Promise.resolve();

function enqueuePhotoQualityAnalysis(file) {
  const task = analysisQueue.then(async () => {
    const { analyzePhoto } = await import('./analyzer');
    return analyzePhoto(file);
  });
  analysisQueue = task.catch(() => {});
  return task;
}

export { enqueuePhotoQualityAnalysis };
